import { AddressType } from "./address-type.model";
import { Editable } from "./editable.model";

export class Address extends Editable {
    /** Unique internal identity of the address. */
    public id: number;

    /** Unique internal identity regarding the type of address this is, i.e. home, mail, etc... */
    public addressTypeId: number;

    /** Meta data regarding the type of address this is, i.e. home, mail, etc... */
    public addressType: AddressType;

    /** Street address associated with the address. */
    public address: string;
    
    /** Street address addenda associated with the address. */
    public address2: string;
    
    /** City associated with the address. */
    public city: string;
    
    /** State associated with the address. */
    public state: string;
    
    /** Postal (zip) code associated with the address. */
    public zipcode: string;
    public zipCode: string;
    
    /** County associated with the address. */
    public county: string;

    /** Country associated with the address. */
    public country: string;

    /** Indicates whether or not the address is the primary residence or place of business. */
    public primaryAddress: boolean;

    /** Current status of the contact address. */
    public status: string;

    /** Date when the contact first started using this address. */
    public startDate: Date;

    /** Date when the contact was last associated with this address, if any. */
    public endDate: Date;
}